import React, { Component } from "react"
import FamilyReferralDeleteButton  from './FamilyReferralDeleteButton.jsx'
import { cellData, emptyReferral } from "./FamilyReferralHelpers";
import { ReferralMbo, Ref2IntakeEPmbo /*, instance*/ } from '../../variables/Config'
import YSpinner from '../../elements/Spinner/Spinner'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'

// FamilyReferralForm
const  microLegend = {
    family_referral_date: "ת. פתיחת הפניה",
    family_referral_family_name: "שם משפחה",
    family_referral_woman_firstname: "שם האשה",
    family_referral_man_firstname: "שם הגבר",
    family_referral_code: "קוד הפניה",
    family_referral_family_code: "קוד אינטייק",
    family_referral_team: "מלווה משפחה",
    family_referral_status: "סטטוס הפניה",
    family_referral_cell_woman: "נייד אשה",
    family_referral_cell_man: "נייד גבר",
    family_referral_initiator: "גורם מפנה",
    family_referral_age_woman: "גיל האשה",
    family_referral_age_man: "גיל הגבר",
    family_referral_merita_status: "סטטוס זוגיות",
    family_referral_num_kids: "מספר ילדים",
    family_refferal_woman_workplace: "מקום עבודה אשה",
    family_refferal_man_workplace: "מקום עבודה גבר",
    family_referral_debts: "חובות משפחה",
    family_referral_os_client: "לקוחה של הרווחה",
    family_referral_prev_plan: "השתתפה בתכנית שיפור",
    family_referral_prev_plan_name: "באיזה תוכנית השתתפה",
    family_referral_phone_call: "האם התבצעה שיחת טלפון",
    family_referral_intake_set: "האם נקבע אינטייק",
    family_referral_intake_date: "תאריך האינטייק",
    family_referral_r1: "קשיים בהתנהלות כלכלית שוטפת",
    family_referral_r2: "חובות כבדים",
    family_referral_r3: "הכנסות נמוכות",
    family_referral_r4: "אבטלה או תעסוקה לא איכותית",
    family_referral_r5: "מצב משפחתי רעוע",
    family_referral_r6: "קשיים של הילדים",
    family_referral_mgr_decision: "החלטת מנהלת",
    family_referral_family_decision: "החלטת המשפחה",
    family_referral_mgr_explain: "הסבר החלטת מנהלת",
    family_referral_family_explain: "הסבר החלטת משפחה"
}

export class FamilyReferralForm extends Component {
    constructor(props) {
      super(props)
      this.state = { 
          products: this.props.data, // this.props.newRF ? newReferral : this.props.data,
          newRF: this.props.newRF,
          intakeCode: 0,
          restError: "",
          isPosting: false // while saving referral to DB
        }
        //this.onSaveTable = this.onSaveTable.bind(this)
        this.onReferralUpdate = this.onReferralUpdate.bind(this)
        this.handleNewFamily = this.handleNewFamily.bind(this)
        this.save2db = this.save2db.bind(this)
        this.handleProductTable = this.handleProductTable.bind(this)
    }
    /*componentDidMount(){
      console.log("FamilyReferralForm, newRF=", this.state.newRF) // initialize if true
      if (this.state.newRF) this.forceUpdate()
    }*/
    // Generate Intake from Referral
    handleNewFamily = (event) => {
      event.preventDefault()
      // alert("handleNewIntake: Creating New Intake Family")
      //let uri_ep = "http://yahav/wp-json/mbo/v3/ref2intake"
      //const uri_ep = Ref2IntakeEPmbo // instance.get_endPoint(Ref2IntakeEPmboNew)
      this.save2db() // save last modifications...

      this.setState({isPosting:true})
      let body ={"acf": this.state.products }
      var responseOK = false
      fetch(Ref2IntakeEPmbo(), {
          method: 'POST',
          headers: { 
            'Accept': 'application/json', 'Authorization': 'Bearer' + this.props.mbouser.token
          },
          body: JSON.stringify({body}) 
      }).then(response => {
          if (response.ok) {
              //let clone = response.clone();
              alert("אינטייק חדש למשפחה נוצר")
              responseOK = true
              return response.json()
          } else  
              throw new Error('handleNewIntake: Something went wrong on fetch POST ... ', this.state.products)
      }).then( data => {
                //const { addReferral } = this.props

                ////console.log("handleNewIntake: got ok from creating / updating new intake", data)
                //let x= clone.json()
                //console.log("handleNewIntake: state", this.state)    //console.log("handleNewIntake: props", this.props)
                //this.state.products['family_referral_family_code']= x['family_referral_family_code']
                data["family_referral_status"] = "עברה לאינטייק" // bypass DB update,just make sure that this happes
                this.setState({isPosting:false, products: data })
                ////////////addReferral(data, false) // newRF is false
                // no need for addReferralIntoList()
                return data
        
      })
      .catch(restError => {
        if (!responseOK){
          console.log("handleNewIntake, fetch POST error:", restError)
          alert(" תקלת מערכת - אינטייק לא נוצר! " + restError)
        }
        this.setState({isPosting:false, restError })
      })
  }
    save2db = () => {
        // var uri_ep = "http://yahav/wp-json/mbo/v3/referrals" // invoke mbo_updateReferral
        //const uri_ep = instance.get_endPoint(NewReferralMbo)
        const uri_ep = ReferralMbo() // instance.get_endPoint(ReferralMboNew)
        this.setState({isPosting:true})

        let body ={
            "acf": this.state.products
        }
        ////console.log("save2db: this.props.mbouser", this.props.mbouser);
        fetch(uri_ep, {
            method: 'POST',
            headers: {
  //            'Access-Control-Request-Headers' : 'Access-Control-Allow-Origin',
  //              'Access-Control-Allow-Origin':'http://localhost:3000', 
 //               'Accept': 'application/json', 'Authorization': 'Basic '+btoa('meital:@site2goal.')
                  'Content-Type': 'application/json',
                  'Accept': 'application/json', 'Authorization': 'Bearer'+this.props.mbouser.token

            },
            body: JSON.stringify({body}) 
        }).then(response => {
                if (response.ok) {
                    return response.json()
                } else {
                    alert("handleUpdateClick תקלת מערכת! העדכונים לאנשמרו במאגר קוד:")
                    throw new Error('Something went wrong on ftch POST ... ', this.state.products)
                }
            })
            .then (data => {
                const { addReferralIntoList } = this.props
                const { newRF} = this.state
 //               alert("handleUpdateClick העדכונים נשמרו במאגר")
                //addReferral(data, newRF)
                addReferralIntoList(data,newRF)
                this.setState({isPosting:false, newRF: false, products: data})
/*
                let clone = response.clone()
                
                var data = clone.json().then(function(data) {
                    console.log("Family Referals New: response.json()-referral ", data)
                    addReferral(data, newRF) // newRF=true -> add, else update
                    this.setState({isPosting:false, newRF: false, products: data})

                    return data
                })
                this.setState({isPosting:false, newRF: false,products: data})
 */               return data
                
            }) 
        .catch(restError => this.setState({ restError: restError, isPosting: false }))
    }
    onReferralUpdate = () => {
        const { products } = this.state

        if (products.family_referral_family_name.length < 2){
            alert ("שם משפחה חייב להכיל 2 תווים")
            return false;
        }
        if (products.family_referral_woman_firstname.length < 2
            && products.family_referral_man_firstname.length < 2 ){
            alert (" יש לספק לפחות שם הורה אחד (באורך שתי אותיות לפחות)")
            return false;
        }
        
        let res = this.save2db() // add Referral to main father list
        //this.setState({products:res})
        //console.log("onReferralUpdate - after set state", res)

        return res
    }
    handleProductTable = (evt) => {
        evt.preventDefault()
        var item = {
            id: evt.target.id,
            name: evt.target.name,
            value: evt.target.value
        }
        var newp = Object.assign(this.state.products)
        for (var key in newp) {
          if (key === item.name) {
              newp[key] = item.value
          }
        }
        this.setState({products:newp})
    }

    render() {
      const {title, removeReferral} = this.props
      const {products, newRF} = this.state
      //if (this.state.isPosting)
      //  return (<YSpinner message={"מעדכן..."} />)
        //return (<h1>מעדכן...</h1>)
      //console.log("Check if after update", products)
      return (
        <div>
          { this.state.isPosting? <YSpinner message={"מעדכן..."} /> : null }
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onReferralUpdate} 
            generateIntake = {this.handleNewFamily}
            removeReferral = {removeReferral}
            tableTitle = {title} 
            product={products} 
            newRF = {newRF}
            intakeCode = {this.state.intakeCode}
            mbouser = { this.props.mbouser }
          />
          </div>
      )
    }
  }
   
  class ProductTable extends Component {
    testReady4Intake = (product, newRF) => {
      return (
        !newRF && product.family_referral_status === "קבלה לאינטייק"
             && (product.family_referral_family_code !== undefined && !(product.family_referral_family_code > 0)) // "not" intake exists
             //&& (product.family_referral_status === "התקבלה לתכנית" || product.family_referral_status === "קבלה לאינטייק") || product.family_referral_status !== "עברה לאינטייק" 
             && product.family_referral_mgr_decision === "קבלה לאינטייק" 
             && product.family_referral_family_decision === "המשך לאינטייק"
      )
    }
    
    notAllowDelete = data => {
      let conds = ["התקבלה לתוכנית", "קבלה לאינטייק", "עברה לאינטייק"]
      return (data === undefined || data.family_referral_family_code > 0 || conds.includes(data.family_referral_status))
    }
    
    deleteButton = (data) => {
      const { removeReferral, mbouser } = this.props
        // event.preventDefault()
        if (this.notAllowDelete(data))
          return null
        return (
            <div style={{ width:'150px',marginLeft:'10px', display: 'inline-block', float:'left'}}>
                <FamilyReferralDeleteButton  postid={data.family_referral_code} 
                    removeReferral={removeReferral} mbouser = { mbouser } />
            </div>
        )    
    }

    render() {            
      const { onProductTableUpdate, product, tableTitle, onSaveTable, newRF, generateIntake, intakeCode } = this.props
      const buttonStyle = {marginRight: '0'}
      const readyForIntake =  this.testReady4Intake(product, newRF)
      const showDeleteButton = !newRF && (!(product.family_referral_family_code > 0) || intakeCode)
 
      return (
        <div >    
            <h2 className="family-name-style" style={{textAlign: 'right'}}>{tableTitle}</h2>
            
            <UpdateButton buttonStyle={buttonStyle} onSaveTable={onSaveTable} newRF={newRF} />

            {showDeleteButton && this.deleteButton(product) } 
            {readyForIntake && <Ref2IntakeButton generateIntake={generateIntake} />}
            
            <div className="mynewdivform" style={{width: '1100px'}}>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    cd={cellData(newRF? emptyReferral : product)}
                    />
            </div>
        </div>
      )
    }
  }

  const Ref2IntakeButton = (props) => {
    return (
      <button onClick={props.generateIntake } 
              type="submit" style={{ width:'150px', float:'left',marginLeft:'10px' }}>העברה לאינטייק</button>
    )
  }
  const UpdateButton = (props) => {
    return (
        <button style={props.buttonStyle} type="button"  className="btn btn-success pull-left" onClick={props.onSaveTable} >
                {props.newRF?"יצירת הפניה": "עדכון הפניה"}
        </button>
    )
  }
  const ProductRow = (props) => {   
      //const {onProductTableUpdate, cd} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {props.cd.map(cellInfo => {
              return(
                <React.Fragment key={key++}>
                  {cellInfo.newsection === undefined ? null : <h3 key={key++} >{cellInfo.newsection}</h3>}
                  <EditableFormCell key={key++} onProductTableUpdate={props.onProductTableUpdate} cellData={cellInfo} />
                </React.Fragment>
              )
          })}
        </div>
      )
  }

  class EditableFormCell extends React.PureComponent {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline" >
              <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
              <SelectF tp={tp} tpc={tpc} />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline" >
              <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
              <TextareaF tp={tp} tpc={tpc} />
            </div>
          )
        }
        return (
          <div className="form-cell-box-inline" >
            <label  htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
            <InputF tp={tp} tpc={tpc} />
          </div>
        )
  
    }
  }
